/* eslint @typescript-eslint/strict-boolean-expressions: off */

import styles from "./TeamProfile.module.css";
import Row from "gui/layout/row";
import { ButtonOld } from "components/ButtonOld/ButtonOld";
import { Icon } from "gui/icon/icon";

import { gql } from "@apollo/client";
import useIsAdminOfTeam from "lib/teams/useIsAdminOfTeam";
import { StaticTeamProfileData } from "../fetchStaticTeamProfileData";

interface Props {
  sectionId: string;
  team: StaticTeamProfileData;
}

export default function ProfileTitle(props: Props) {
  const isEditable = useIsAdminOfTeam(props.team.id!);
  const { team } = props;

  return (
    <Row layout="center-aligned" className={styles["profile-title"]}>
      <h1 id={props.sectionId}>{team.name}</h1>

      <ButtonOld size="sm" color2 light href="/settings/teams">
        Team
      </ButtonOld>
      {(team.serviceTierName || isEditable) && (
        <Row>
          {isEditable && (
            <>
              <EditProfileButton teamHandle={props.team.handle} />
            </>
          )}
        </Row>
      )}
    </Row>
  );
}

function EditProfileButton(props: { teamHandle: string }) {
  return (
    <>
      <ButtonOld
        href={`/settings/teams/manage/${props.teamHandle}/profile`}
        size="sm"
      >
        <Row gap="small">
          <span>Edit</span>
          <Icon className={styles["button-icon"]} icon={"edit"} />
        </Row>
      </ButtonOld>
    </>
  );
}

gql`
  query GetMembership($user_id: Int!, $team_id: Int!) {
    memberships(
      where: {
        user_id: { _eq: $user_id }
        _and: { team_id: { _eq: $team_id } }
      }
    ) {
      id
      private_details {
        role
        status
      }
    }
  }
`;
